/* ShivaRam · generador de PDF en el propio dispositivo del visitante.
   - Sin librerías ni servicios externos: el PDF se compone aquí mismo y se descarga directamente.
   - No guarda nada ni envía datos a ningún servidor.
   - Fuentes estándar del PDF (Helvetica y Times) con codificación WinAnsi (español, inglés, francés, alemán).
   Uso: var d = ShivaPDF.doc({ titulo, subtitulo, fecha, pie, idioma }); d.h2('...'); d.p('...'); ... d.guardar('archivo.pdf'); */
(function () {
  'use strict';
  if (window.ShivaPDF) return;

  var W = {
  H: [278,278,355,556,556,889,667,191,333,333,389,584,278,333,278,278,556,556,556,556,556,556,556,556,556,556,278,278,584,584,584,556,1015,667,667,722,722,667,611,778,722,278,500,667,556,833,722,778,667,778,722,667,611,722,667,944,667,667,611,278,278,278,469,556,333,556,556,500,556,556,278,556,556,222,222,500,222,833,556,556,556,556,333,500,278,556,500,722,500,500,500,334,260,334,584,761,556,0,222,556,333,1000,556,556,333,1000,667,333,1000,0,611,0,0,222,222,333,333,350,556,1000,333,1000,500,333,944,0,500,667,278,333,556,556,556,556,260,556,333,737,370,556,584,333,737,333,400,584,333,333,333,556,537,278,333,333,365,556,834,834,834,611,667,667,667,667,667,667,1000,722,667,667,667,667,278,278,278,278,722,722,778,778,778,778,778,584,778,722,722,722,722,667,667,611,556,556,556,556,556,556,889,500,556,556,556,556,278,278,278,278,556,556,556,556,556,556,556,584,611,556,556,556,556,500,556,500],
  HB: [278,333,474,556,556,889,722,238,333,333,389,584,278,333,278,278,556,556,556,556,556,556,556,556,556,556,333,333,584,584,584,611,975,722,722,722,722,667,611,778,722,278,556,722,611,833,722,778,667,778,722,667,611,722,667,944,667,667,611,333,278,333,584,556,333,556,611,556,611,556,333,611,611,278,278,556,278,889,611,611,611,611,389,556,333,611,556,778,556,556,500,389,280,389,584,761,556,0,278,556,500,1000,556,556,333,1000,667,333,1000,0,611,0,0,278,278,500,500,350,556,1000,333,1000,556,333,944,0,500,667,278,333,556,556,556,556,280,556,333,737,370,556,584,333,737,333,400,584,333,333,333,611,556,278,333,333,365,556,834,834,834,611,722,722,722,722,722,722,1000,722,667,667,667,667,278,278,278,278,722,722,778,778,778,778,778,584,778,722,722,722,722,667,667,611,556,556,556,556,556,556,889,556,556,556,556,556,278,278,278,278,611,611,611,611,611,611,611,584,611,611,611,611,611,556,611,556],
  T: [250,333,408,500,500,833,778,180,333,333,500,564,250,333,250,278,500,500,500,500,500,500,500,500,500,500,278,278,564,564,564,444,921,722,667,667,722,611,556,722,722,333,389,722,611,889,722,722,556,722,667,556,611,722,722,944,722,722,611,333,278,333,469,500,333,444,500,444,500,444,333,500,500,278,278,500,278,778,500,500,500,500,333,389,278,500,500,722,500,500,444,480,200,480,541,761,500,0,333,500,444,1000,500,500,333,1000,556,333,889,0,611,0,0,333,333,444,444,350,500,1000,333,980,389,333,722,0,444,722,250,333,500,500,500,500,200,500,333,760,276,500,564,333,760,333,400,564,300,300,333,500,453,250,333,300,310,500,750,750,750,444,722,722,722,722,722,722,889,667,611,611,611,611,333,333,333,333,722,722,722,722,722,722,722,564,722,722,722,722,722,722,556,500,444,444,444,444,444,444,667,444,444,444,444,444,278,278,278,278,500,500,500,500,500,500,500,564,500,500,500,500,500,500,500,500],
  TB: [250,333,555,500,500,1000,833,278,333,333,500,570,250,333,250,278,500,500,500,500,500,500,500,500,500,500,333,333,570,570,570,500,930,722,667,722,722,667,611,778,778,389,500,778,667,944,722,778,611,778,722,556,667,722,722,1000,722,722,667,333,278,333,581,500,333,500,556,444,556,444,333,500,556,278,333,556,278,833,556,500,556,556,444,389,333,556,500,722,500,500,444,394,220,394,520,761,500,0,333,500,500,1000,500,500,333,1000,556,333,1000,0,667,0,0,333,333,500,500,350,500,1000,333,1000,389,333,722,0,444,722,250,333,500,500,500,500,220,500,333,747,300,500,570,333,747,333,400,570,300,300,333,556,540,250,333,300,330,500,750,750,750,500,722,722,722,722,722,722,1000,722,667,667,667,667,389,389,389,389,722,722,778,778,778,778,778,570,778,722,722,722,722,722,611,556,500,500,500,500,500,500,722,444,444,444,444,444,278,278,278,278,500,556,500,500,500,500,500,570,500,556,556,556,556,500,556,500],
  TI: [250,333,420,500,500,833,778,214,333,333,500,675,250,333,250,278,500,500,500,500,500,500,500,500,500,500,333,333,675,675,675,500,920,611,611,667,722,611,611,722,722,333,444,667,556,833,667,722,611,722,611,500,556,722,611,833,611,556,556,389,278,389,422,500,333,500,500,444,500,444,278,500,500,278,278,444,278,722,500,500,500,500,389,389,278,500,444,667,444,444,389,400,275,400,541,761,500,0,333,500,556,889,500,500,333,1000,500,333,944,0,556,0,0,333,333,556,556,350,500,889,333,980,389,333,667,0,389,556,250,389,500,500,500,500,275,500,333,760,276,500,675,333,760,333,400,675,300,300,333,500,523,250,333,300,310,500,750,750,750,500,611,611,611,611,611,611,889,667,611,611,611,611,333,333,333,333,722,667,722,722,722,722,722,675,722,722,722,722,722,556,611,500,500,500,500,500,500,500,667,444,444,444,444,444,278,278,278,278,500,500,500,500,500,500,500,675,500,500,500,500,500,444,500,444]
};

  var PW = 595.28, PH = 841.89, ML = 54, MR = 54, MB = 64;
  var C = { navy: [23, 43, 77], gold: [198, 161, 91], goldDark: [138, 109, 47], cream: [251, 248, 242], goldSoft: [239, 228, 204], text: [38, 50, 74], muted: [95, 107, 128], white: [255, 255, 255], line: [216, 210, 196], warn: [255, 246, 229] };
  var FONTS = { H: 'Helvetica', HB: 'Helvetica-Bold', HI: 'Helvetica-Oblique', T: 'Times-Roman', TB: 'Times-Bold', TI: 'Times-Italic' };
  var FID = { H: 'F1', HB: 'F2', HI: 'F3', T: 'F4', TB: 'F5', TI: 'F6' };
  function widths(f) { return W[f === 'HI' ? 'H' : f]; }

  /* ---------- codificación de texto (Unicode → WinAnsi) ---------- */
  var CP = { 8364: 128, 8218: 130, 402: 131, 8222: 132, 8230: 133, 8224: 134, 8225: 135, 710: 136, 8240: 137, 352: 138, 8249: 139, 338: 140, 381: 142, 8216: 145, 8217: 146, 8220: 147, 8221: 148, 8226: 149, 8211: 150, 8212: 151, 732: 152, 8482: 153, 353: 154, 8250: 155, 339: 156, 382: 158, 376: 159 };
  var SUST = { 8242: "'", 8243: '"', 8722: '-', 8209: '-', 8208: '-', 8201: ' ', 8239: ' ', 8202: ' ', 8203: '', 8288: '', 65279: '', 8594: '->', 8592: '<-', 9679: '•', 9733: '*', 9734: '*', 10003: 'v', 304: 'I', 305: 'i' };
  function bytesDe(str) {
    var out = [];
    str = String(str == null ? '' : str);
    for (var i = 0; i < str.length; i++) {
      var c = str.charCodeAt(i);
      if (c === 9) { out.push(32); continue; }
      if (c >= 32 && c < 127) { out.push(c); continue; }
      if (c >= 160 && c <= 255) { out.push(c === 160 ? 32 : c); continue; }
      if (CP[c]) { out.push(CP[c]); continue; }
      if (SUST[c] != null) { var s = SUST[c]; for (var j = 0; j < s.length; j++) out = out.concat(bytesDe(s[j])); continue; }
      if (c >= 0xD800 && c <= 0xDBFF) { i++; continue; } // emoji y similares: se omiten
      var base = String.fromCharCode(c).normalize ? String.fromCharCode(c).normalize('NFD').replace(/[̀-ͯ]/g, '') : '';
      if (base && base.charCodeAt(0) < 256 && base.charCodeAt(0) >= 32) out.push(base.charCodeAt(0));
      else if (c >= 0x0300 && c <= 0x036f) continue;
      else out.push(63);
    }
    return out;
  }
  function anchoBytes(b, f, size, tc) {
    var w = widths(f), s = 0;
    for (var i = 0; i < b.length; i++) s += (b[i] >= 32 ? w[b[i] - 32] : 0) || 500;
    return s / 1000 * size + (tc || 0) * b.length;
  }
  function ancho(str, f, size, tc) { return anchoBytes(bytesDe(str), f, size, tc); }
  function lit(b) {
    var s = '(';
    for (var i = 0; i < b.length; i++) {
      var c = b[i];
      if (c === 40 || c === 41 || c === 92) s += '\\' + String.fromCharCode(c);
      else if (c < 32 || c > 126) s += '\\' + ('00' + c.toString(8)).slice(-3);
      else s += String.fromCharCode(c);
    }
    return s + ')';
  }
  function n(x) { return (Math.round(x * 100) / 100).toString(); }
  function rgb(c) { return n(c[0] / 255) + ' ' + n(c[1] / 255) + ' ' + n(c[2] / 255); }

  /* ---------- partir texto en líneas ---------- */
  function lineas(texto, f, size, maxW, tc) {
    var res = [];
    String(texto == null ? '' : texto).replace(/\r/g, '').split('\n').forEach(function (par) {
      var palabras = par.replace(/[ \t ]+/g, ' ').trim().split(' ');
      var linea = '';
      palabras.forEach(function (w) {
        if (!w) return;
        var prueba = linea ? linea + ' ' + w : w;
        if (ancho(prueba, f, size, tc) <= maxW) { linea = prueba; return; }
        if (linea) res.push(linea);
        // palabra más larga que la línea: se corta por caracteres
        while (ancho(w, f, size, tc) > maxW) {
          var k = w.length - 1;
          while (k > 1 && ancho(w.slice(0, k), f, size, tc) > maxW) k--;
          res.push(w.slice(0, k)); w = w.slice(k);
        }
        linea = w;
      });
      res.push(linea);
    });
    return res;
  }

  /* ---------- utilidades binarias ---------- */
  function strBytes(s) { var a = new Uint8Array(s.length); for (var i = 0; i < s.length; i++) a[i] = s.charCodeAt(i) & 255; return a; }
  function dataURLaBytes(u) { var b = atob(u.split(',')[1]), a = new Uint8Array(b.length); for (var i = 0; i < b.length; i++) a[i] = b.charCodeAt(i); return a; }
  function hexUTF16(str) { var h = 'FEFF'; for (var i = 0; i < str.length; i++) h += ('000' + str.charCodeAt(i).toString(16)).slice(-4); return '<' + h.toUpperCase() + '>'; }

  /* ---------- imágenes (JPEG) generadas en el dispositivo ---------- */
  function canvasAJpeg(cv, calidad) { return { bytes: dataURLaBytes(cv.toDataURL('image/jpeg', calidad || 0.88)), w: cv.width, h: cv.height }; }
  function cargarImagen(src) {
    return new Promise(function (ok, ko) {
      var img = new Image();
      img.onload = function () { ok(img); };
      img.onerror = function () { ko(new Error('img')); };
      img.src = src;
    });
  }
  function imagenAJpeg(src, maxLado, fondo) {
    return cargarImagen(src).then(function (img) {
      var w = img.naturalWidth || img.width, h = img.naturalHeight || img.height;
      var k = Math.min(1, (maxLado || 1400) / Math.max(w, h));
      var cv = document.createElement('canvas'); cv.width = Math.max(1, Math.round(w * k)); cv.height = Math.max(1, Math.round(h * k));
      var ctx = cv.getContext('2d'); ctx.fillStyle = fondo || '#ffffff'; ctx.fillRect(0, 0, cv.width, cv.height);
      ctx.drawImage(img, 0, 0, cv.width, cv.height);
      return canvasAJpeg(cv, 0.86);
    });
  }
  function svgAJpeg(svg, anchoPx, fondo) {
    var m = /viewBox="\s*([\d.-]+)[ ,]+([\d.-]+)[ ,]+([\d.]+)[ ,]+([\d.]+)/.exec(svg) || [0, 0, 0, 200, 320];
    var vw = +m[3], vh = +m[4], w = anchoPx || 600, h = Math.round(w * vh / vw);
    var s = svg.replace(/<svg\b([^>]*)>/, function (all, at) {
      at = at.replace(/\swidth="[^"]*"/, '').replace(/\sheight="[^"]*"/, '');
      if (!/xmlns=/.test(at)) at += ' xmlns="http://www.w3.org/2000/svg"';
      return '<svg' + at + ' width="' + w + '" height="' + h + '">';
    });
    return cargarImagen('data:image/svg+xml;charset=utf-8,' + encodeURIComponent(s)).then(function (img) {
      var cv = document.createElement('canvas'); cv.width = w; cv.height = h;
      var ctx = cv.getContext('2d'); ctx.fillStyle = fondo || '#ffffff'; ctx.fillRect(0, 0, w, h);
      ctx.drawImage(img, 0, 0, w, h);
      return canvasAJpeg(cv, 0.9);
    });
  }

  /* ---------- documento ---------- */
  function Doc(o) {
    this.o = o || {};
    this.pags = [];
    this.imgs = [];
    this.nueva();
  }
  var D = Doc.prototype;
  D.nueva = function () {
    this.s = [];
    this.pags.push(this.s);
    this.y = this.pags.length === 1 ? 176 : 70;
  };
  D.libre = function () { return PH - MB - this.y; };
  D.asegurar = function (h) { if (this.y + h > PH - MB) { this.nueva(); return true; } return false; };
  D.op = function (s) { this.s.push(s); };
  D.rect = function (x, y, w, h, fill, stroke, lw) {
    if (fill) this.op(rgb(fill) + ' rg');
    if (stroke) this.op(rgb(stroke) + ' RG ' + n(lw || 0.6) + ' w');
    this.op(n(x) + ' ' + n(PH - y - h) + ' ' + n(w) + ' ' + n(h) + ' re ' + (fill && stroke ? 'B' : fill ? 'f' : 'S'));
  };
  D.rrect = function (x, y, w, h, r, fill, stroke, lw) {
    var k = 0.5523 * r, X = x, Y = PH - y - h;
    var p = [n(X + r) + ' ' + n(Y) + ' m', n(X + w - r) + ' ' + n(Y) + ' l', n(X + w - r + k) + ' ' + n(Y) + ' ' + n(X + w) + ' ' + n(Y + r - k) + ' ' + n(X + w) + ' ' + n(Y + r) + ' c',
      n(X + w) + ' ' + n(Y + h - r) + ' l', n(X + w) + ' ' + n(Y + h - r + k) + ' ' + n(X + w - r + k) + ' ' + n(Y + h) + ' ' + n(X + w - r) + ' ' + n(Y + h) + ' c',
      n(X + r) + ' ' + n(Y + h) + ' l', n(X + r - k) + ' ' + n(Y + h) + ' ' + n(X) + ' ' + n(Y + h - r + k) + ' ' + n(X) + ' ' + n(Y + h - r) + ' c',
      n(X) + ' ' + n(Y + r) + ' l', n(X) + ' ' + n(Y + r - k) + ' ' + n(X + r - k) + ' ' + n(Y) + ' ' + n(X + r) + ' ' + n(Y) + ' c'];
    if (fill) this.op(rgb(fill) + ' rg');
    if (stroke) this.op(rgb(stroke) + ' RG ' + n(lw || 0.6) + ' w');
    this.op(p.join(' ') + ' h ' + (fill && stroke ? 'B' : fill ? 'f' : 'S'));
  };
  D.linea = function (x1, y1, x2, y2, color, lw) { this.op(rgb(color || C.gold) + ' RG ' + n(lw || 0.6) + ' w ' + n(x1) + ' ' + n(PH - y1) + ' m ' + n(x2) + ' ' + n(PH - y2) + ' l S'); };
  D.circulo = function (cx, cy, r, color, lw, fill) {
    var k = 0.5523 * r, X = cx, Y = PH - cy;
    var p = n(X + r) + ' ' + n(Y) + ' m ' + n(X + r) + ' ' + n(Y + k) + ' ' + n(X + k) + ' ' + n(Y + r) + ' ' + n(X) + ' ' + n(Y + r) + ' c ' + n(X - k) + ' ' + n(Y + r) + ' ' + n(X - r) + ' ' + n(Y + k) + ' ' + n(X - r) + ' ' + n(Y) + ' c ' + n(X - r) + ' ' + n(Y - k) + ' ' + n(X - k) + ' ' + n(Y - r) + ' ' + n(X) + ' ' + n(Y - r) + ' c ' + n(X + k) + ' ' + n(Y - r) + ' ' + n(X + r) + ' ' + n(Y - k) + ' ' + n(X + r) + ' ' + n(Y) + ' c';
    this.op((fill ? rgb(fill) + ' rg ' : '') + rgb(color || C.gold) + ' RG ' + n(lw || 0.6) + ' w ' + p + (fill ? ' B' : ' S'));
  };
  // texto en una línea; y = línea base
  D.txt = function (s, x, y, f, size, color, tc, alinear) {
    var b = bytesDe(s);
    if (alinear === 'center') x -= anchoBytes(b, f, size, tc) / 2;
    else if (alinear === 'right') x -= anchoBytes(b, f, size, tc);
    this.op('BT /' + FID[f] + ' ' + n(size) + ' Tf ' + rgb(color || C.text) + ' rg ' + (tc ? n(tc) + ' Tc ' : '0 Tc ') + n(x) + ' ' + n(PH - y) + ' Td ' + lit(b) + ' Tj ET');
  };
  D.imagen = function (img, x, y, w, h) {
    var id = this.imgs.indexOf(img);
    if (id < 0) { this.imgs.push(img); id = this.imgs.length - 1; }
    this.op('q ' + n(w) + ' 0 0 ' + n(h) + ' ' + n(x) + ' ' + n(PH - y - h) + ' cm /Im' + (id + 1) + ' Do Q');
  };

  /* ---------- bloques de alto nivel ---------- */
  var AW = PW - ML - MR;
  // párrafo con salto de página automático
  D.p = function (s, op) {
    op = op || {};
    if (s == null || String(s).trim() === '') return this;
    var f = op.f || 'H', size = op.size || 10, lead = op.lead || size * 1.5, x = op.x != null ? op.x : ML, w = op.w || (PW - MR - x), color = op.color || C.text, tc = op.tc || 0;
    var ls = lineas(op.mayus ? String(s).toUpperCase() : s, f, size, w, tc);
    var self = this;
    ls.forEach(function (l) {
      if (self.asegurar(lead)) {}
      self.txt(l, op.align === 'center' ? x + w / 2 : x, self.y + size, f, size, color, tc, op.align);
      self.y += lead;
    });
    this.y += op.after != null ? op.after : 4;
    return this;
  };
  D.alto = function (s, op) {
    op = op || {};
    var f = op.f || 'H', size = op.size || 10, lead = op.lead || size * 1.5, x = op.x != null ? op.x : ML, w = op.w || (PW - MR - x);
    return lineas(op.mayus ? String(s).toUpperCase() : s, f, size, w, op.tc || 0).length * lead;
  };
  D.espacio = function (h) { this.y += h; return this; };
  // etiqueta pequeña en dorado (mayúsculas con espaciado)
  D.etiqueta = function (s, op) {
    op = op || {};
    this.asegurar(op.conSiguiente || 30);
    return this.p(s, { f: 'HB', size: 7.6, tc: 1, mayus: true, color: op.color || C.goldDark, after: 2, x: op.x, w: op.w, lead: 11 });
  };
  // título de sección: píldora + título en Times
  D.seccion = function (titulo, pildora, op) {
    op = op || {};
    this.asegurar(op.conSiguiente || 90);
    this.y += 8;
    if (pildora) {
      var t = String(pildora).toUpperCase(), wpx = ancho(t, 'HB', 6.8, 0.9) + 16;
      this.rrect(ML, this.y, wpx, 15, 7.5, op.dorada ? C.gold : C.navy);
      this.txt(t, ML + 8, this.y + 10.2, 'HB', 6.8, op.dorada ? C.navy : C.white, 0.9);
      this.y += 22;
    }
    this.p(titulo, { f: 'T', size: 17, lead: 21, color: C.navy, after: 4 });
    this.linea(ML, this.y, ML + 46, this.y, C.gold, 1.2);
    this.y += 12;
    return this;
  };
  D.h3 = function (s, op) { op = op || {}; this.asegurar(op.conSiguiente || 60); return this.p(s, { f: 'T', size: op.size || 14, lead: (op.size || 14) * 1.25, color: C.navy, x: op.x, w: op.w, after: op.after != null ? op.after : 2 }); };
  // bloque etiqueta + texto (como en pantalla)
  D.bloque = function (tit, txt, op) {
    op = op || {};
    if (!txt) return this;
    var x = op.x != null ? op.x : ML, w = op.w || (PW - MR - x);
    if (op.destacado) {
      var pad = 9, hT = this.alto(tit, { f: 'HB', size: 7.6, tc: 1, mayus: true, lead: 11, w: w - 2 * pad - 3 }) + 2, hP = this.alto(txt, { size: 10, lead: 15, w: w - 2 * pad - 3, f: op.f });
      var h = hT + hP + 2 * pad;
      if (h < PH - MB - 70) this.asegurar(h + 6);
      var y0 = this.y;
      this.rect(x, y0, w, h, C.cream);
      this.rect(x, y0, 2.4, h, C.gold);
      this.y += pad;
      this.etiqueta(tit, { x: x + pad + 3, w: w - 2 * pad - 3 });
      this.p(txt, { x: x + pad + 3, w: w - 2 * pad - 3, lead: 15, f: op.f, color: op.color, after: 0 });
      this.y = Math.max(this.y, y0 + h) + 10;
      return this;
    }
    this.asegurar(11 + 15 * Math.min(3, Math.ceil(this.alto(txt, { w: w }) / 15)));
    if (tit) this.etiqueta(tit, { x: x, w: w, conSiguiente: 40 });
    this.p(txt, { x: x, w: w, lead: 15, f: op.f, color: op.color, after: op.after != null ? op.after : 9 });
    return this;
  };
  // aviso (fondo crema cálido con barra dorada)
  D.aviso = function (txt, op) {
    op = op || {};
    var x = op.x != null ? op.x : ML, w = op.w || AW, pad = 9;
    var h = this.alto(txt, { size: 9, lead: 13.5, w: w - 2 * pad - 3 }) + 2 * pad;
    this.asegurar(h + 6);
    var y0 = this.y;
    this.rect(x, y0, w, h, C.warn); this.rect(x, y0, 2.4, h, C.gold);
    this.y += pad;
    this.p(txt, { x: x + pad + 3, w: w - 2 * pad - 3, size: 9, lead: 13.5, after: 0 });
    this.y = y0 + h + 8;
    return this;
  };
  D.nota = function (txt, op) { op = op || {}; return this.p(txt, { size: op.size || 8.4, lead: (op.size || 8.4) * 1.5, color: C.muted, align: op.align, x: op.x, w: op.w, f: op.f, after: op.after != null ? op.after : 6 }); };
  D.vinetas = function (items, op) {
    op = op || {};
    var x = op.x != null ? op.x : ML, w = op.w || (PW - MR - x), self = this;
    items.forEach(function (it) {
      if (!it) return;
      var partes = typeof it === 'string' ? { t: it } : it;
      var txt = (partes.b ? partes.b + ' ' : '') + (partes.t || '');
      var ls = lineas(txt, 'H', 10, w - 14, 0);
      ls.forEach(function (l, i) {
        self.asegurar(15);
        if (i === 0) self.circulo(x + 3, self.y + 7, 1.6, C.gold, 0.6, C.gold);
        if (i === 0 && partes.b && l.indexOf(partes.b) === 0) {
          self.txt(partes.b, x + 14, self.y + 10, 'HB', 10, C.navy);
          self.txt(l.slice(partes.b.length), x + 14 + ancho(partes.b, 'HB', 10), self.y + 10, 'H', 10, C.text);
        } else self.txt(l, x + 14, self.y + 10, 'H', 10, C.text);
        self.y += 15;
      });
      self.y += 3;
    });
    this.y += 4;
    return this;
  };
  // pares clave–valor en dos columnas
  D.datos = function (pares, op) {
    op = op || {};
    var x = op.x != null ? op.x : ML, w = op.w || AW, kw = op.kw || Math.min(170, w * 0.38), self = this;
    pares.forEach(function (pv, i) {
      var lk = lineas(pv[0], 'H', 9.2, kw - 8, 0), lv = lineas(pv[1], 'HB', 9.2, w - kw - 8, 0);
      var h = Math.max(lk.length, lv.length) * 13 + 8;
      self.asegurar(h);
      if (i % 2 === 0) self.rect(x, self.y, w, h, C.cream);
      lk.forEach(function (l, j) { self.txt(l, x + 8, self.y + 13 + j * 13, 'H', 9.2, C.muted); });
      lv.forEach(function (l, j) { self.txt(l, x + kw, self.y + 13 + j * 13, 'HB', 9.2, C.navy); });
      self.y += h;
    });
    this.y += 10;
    return this;
  };
  // tabla sencilla con cabecera repetida en cada página
  D.tabla = function (cab, filas, op) {
    op = op || {};
    var x = ML, w = AW, nc = cab.length, self = this;
    var pesos = op.pesos || cab.map(function () { return 1; }), tot = pesos.reduce(function (a, b) { return a + b; }, 0);
    var cw = pesos.map(function (p) { return w * p / tot; });
    var size = op.size || 8.8;
    function cabecera() {
      self.rect(x, self.y, w, 20, C.navy);
      cab.forEach(function (c, i) { var xx = x + cw.slice(0, i).reduce(function (a, b) { return a + b; }, 0); self.txt(String(c).toUpperCase(), xx + 6, self.y + 13.2, 'HB', 6.8, C.gold, 0.6); });
      self.y += 20;
    }
    this.asegurar(20 + 18 * Math.min(3, filas.length));
    cabecera();
    filas.forEach(function (f, r) {
      var celdas = f.c || f, dest = f.destacada;
      var ls = celdas.map(function (c, i) { return lineas(c, i === 0 ? 'HB' : 'H', size, cw[i] - 10, 0); });
      var h = Math.max.apply(null, ls.map(function (l) { return l.length; })) * (size * 1.35) + 8;
      if (self.y + h > PH - MB) { self.nueva(); cabecera(); }
      if (dest) self.rect(x, self.y, w, h, [253, 244, 226]); else if (r % 2) self.rect(x, self.y, w, h, C.cream);
      ls.forEach(function (l, i) {
        var xx = x + cw.slice(0, i).reduce(function (a, b) { return a + b; }, 0);
        l.forEach(function (t, j) { self.txt(t, xx + 6, self.y + 4 + size + j * size * 1.35, i === 0 ? 'HB' : 'H', size, i === 0 ? C.navy : C.text); });
      });
      self.linea(x, self.y + h, x + w, self.y + h, C.goldSoft, 0.5);
      self.y += h;
    });
    this.y += 10;
    return this;
  };
  // imagen con proporción; alinear: 'left' | 'center'
  D.foto = function (img, w, op) {
    op = op || {};
    var h = w * img.h / img.w;
    if (op.maxH && h > op.maxH) { h = op.maxH; w = h * img.w / img.h; }
    this.asegurar(h + (op.pie ? 18 : 6));
    var x = op.x != null ? op.x : (op.align === 'center' ? (PW - w) / 2 : ML);
    if (op.marco) this.rrect(x - 3, this.y - 3, w + 6, h + 6, 6, C.white, C.goldSoft, 0.8);
    this.imagen(img, x, this.y, w, h);
    this.y += h + 6;
    if (op.pie) this.p(op.pie, { size: 8, color: C.muted, align: 'center', x: x - 40, w: w + 80, after: 4, lead: 11 });
    return { x: x, w: w, h: h };
  };
  D.separador = function () {
    this.asegurar(24);
    this.y += 6;
    var cx = PW / 2;
    this.linea(cx - 70, this.y, cx - 10, this.y, C.gold, 0.6);
    this.linea(cx + 10, this.y, cx + 70, this.y, C.gold, 0.6);
    this.op(rgb(C.gold) + ' rg ' + n(cx) + ' ' + n(PH - this.y - 3) + ' m ' + n(cx + 3) + ' ' + n(PH - this.y) + ' l ' + n(cx) + ' ' + n(PH - this.y + 3) + ' l ' + n(cx - 3) + ' ' + n(PH - this.y) + ' l h f');
    this.y += 16;
    return this;
  };

  /* ---------- cabecera y pie de cada página ---------- */
  D.decorar = function () {
    var o = this.o, total = this.pags.length, self = this;
    this.pags.forEach(function (pg, i) {
      self.s = [];
      if (i === 0) {
        self.rect(0, 0, PW, 150, C.navy);
        self.rect(0, 150, PW, 3, C.gold);
        // emblema: círculos y estrella
        var cx = PW - MR - 34, cy = 76;
        self.circulo(cx, cy, 34, C.gold, 0.8);
        self.circulo(cx, cy, 26, C.gold, 0.4);
        var pts = [];
        for (var k = 0; k < 16; k++) { var a = -Math.PI / 2 + k * Math.PI / 8, r = k % 2 ? 7 : 20; pts.push(n(cx + r * Math.cos(a)) + ' ' + n(PH - cy - r * Math.sin(a))); }
        self.op(rgb(C.gold) + ' rg ' + pts[0] + ' m ' + pts.slice(1).map(function (p) { return p + ' l'; }).join(' ') + ' h f');
        self.circulo(cx, cy, 3.5, C.navy, 0.1, C.navy);
        self.txt('SHIVARAM', ML, 46, 'TB', 10.5, C.gold, 3.2);
        var tl = lineas(o.titulo || '', 'T', 24, PW - ML - MR - 100, 0);
        var ty = 82;
        if (tl.length > 1) { tl = lineas(o.titulo || '', 'T', 20, PW - ML - MR - 100, 0); }
        tl.slice(0, 2).forEach(function (l, j) { self.txt(l, ML, ty + j * (tl.length > 1 ? 23 : 28), 'T', tl.length > 1 ? 20 : 24, C.white); });
        var yy = ty + (tl.length > 1 ? 23 * Math.min(2, tl.length) : 28) + 2;
        if (o.subtitulo) { lineas(o.subtitulo, 'H', 9.5, PW - ML - MR - 100, 0).slice(0, 2).forEach(function (l, j) { self.txt(l, ML, yy + j * 13, 'H', 9.5, [223, 228, 238]); }); }
        if (o.fecha) self.txt(o.fecha, ML, 140, 'H', 8, C.gold, 0.4);
      } else {
        self.txt('SHIVARAM', ML, 40, 'TB', 8, C.gold, 2.4);
        self.txt(o.titulo || '', PW - MR, 40, 'H', 8, C.muted, 0, 'right');
        self.linea(ML, 48, PW - MR, 48, C.goldSoft, 0.6);
      }
      self.linea(ML, PH - 44, PW - MR, PH - 44, C.goldSoft, 0.6);
      self.txt(o.pie || ('ShivaRam · ' + (o.titulo || '')), ML, PH - 30, 'H', 7.5, C.muted);
      self.txt(String(o.pagina || '{n} / {t}').replace('{n}', i + 1).replace('{t}', total), PW - MR, PH - 30, 'H', 7.5, C.muted, 0, 'right');
      pg.unshift.apply(pg, self.s);
    });
  };

  /* ---------- serialización ---------- */
  D.bytes = function () {
    this.decorar();
    var partes = [], off = 0, xref = [], self = this;
    function add(x) { var b = typeof x === 'string' ? strBytes(x) : x; partes.push(b); off += b.length; }
    var nFont = 6, nImg = this.imgs.length, nPag = this.pags.length;
    // numeración: 1 catálogo, 2 páginas, 3 info, 4..9 fuentes, imágenes, luego (página, contenido) por cada página
    var idFont = 4, idImg = idFont + nFont, idPag = idImg + nImg;
    var total = idPag + nPag * 2 - 1;
    add('%PDF-1.4\n%âãÏÓ\n');
    function obj(id, cuerpo, stream) {
      xref[id] = off;
      add(id + ' 0 obj\n' + cuerpo);
      if (stream) { add('\nstream\n'); add(stream); add('\nendstream'); }
      add('\nendobj\n');
    }
    var kids = [];
    for (var i = 0; i < nPag; i++) kids.push((idPag + i * 2) + ' 0 R');
    obj(1, '<< /Type /Catalog /Pages 2 0 R /ViewerPreferences << /DisplayDocTitle true >> >>');
    obj(2, '<< /Type /Pages /Kids [' + kids.join(' ') + '] /Count ' + nPag + ' >>');
    var d = new Date(), pad = function (x) { return ('0' + x).slice(-2); };
    obj(3, '<< /Title ' + hexUTF16(this.o.titulo || 'ShivaRam') + ' /Author (ShivaRam) /Producer (ShivaRam) /CreationDate (D:' + d.getFullYear() + pad(d.getMonth() + 1) + pad(d.getDate()) + pad(d.getHours()) + pad(d.getMinutes()) + pad(d.getSeconds()) + ') >>');
    var fk = ['H', 'HB', 'HI', 'T', 'TB', 'TI'];
    fk.forEach(function (k, j) { obj(idFont + j, '<< /Type /Font /Subtype /Type1 /BaseFont /' + FONTS[k] + ' /Encoding /WinAnsiEncoding >>'); });
    this.imgs.forEach(function (im, j) { obj(idImg + j, '<< /Type /XObject /Subtype /Image /Width ' + im.w + ' /Height ' + im.h + ' /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ' + im.bytes.length + ' >>', im.bytes); });
    var fontRes = '/Font << ' + fk.map(function (k, j) { return '/' + FID[k] + ' ' + (idFont + j) + ' 0 R'; }).join(' ') + ' >>';
    var imgRes = nImg ? ' /XObject << ' + this.imgs.map(function (im, j) { return '/Im' + (j + 1) + ' ' + (idImg + j) + ' 0 R'; }).join(' ') + ' >>' : '';
    this.pags.forEach(function (pg, i) {
      var id = idPag + i * 2, c = strBytes(pg.join('\n'));
      obj(id, '<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ' + n(PW) + ' ' + n(PH) + '] /Resources << ' + fontRes + imgRes + ' >> /Contents ' + (id + 1) + ' 0 R >>');
      obj(id + 1, '<< /Length ' + c.length + ' >>', c);
    });
    var xo = off, s = 'xref\n0 ' + (total + 1) + '\n0000000000 65535 f \n';
    for (var k = 1; k <= total; k++) s += ('0000000000' + (xref[k] || 0)).slice(-10) + ' 00000 n \n';
    add(s + 'trailer\n<< /Size ' + (total + 1) + ' /Root 1 0 R /Info 3 0 R >>\nstartxref\n' + xo + '\n%%EOF\n');
    var outLen = partes.reduce(function (a, b) { return a + b.length; }, 0), out = new Uint8Array(outLen), p = 0;
    partes.forEach(function (b) { out.set(b, p); p += b.length; });
    return out;
  };

  /* ---------- descarga (móvil y ordenador) ---------- */
  function descargar(bytes, nombre) {
    var blob = new Blob([bytes], { type: 'application/pdf' });
    if (window.navigator && navigator.msSaveOrOpenBlob) { navigator.msSaveOrOpenBlob(blob, nombre); return null; }
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url; a.download = nombre; a.rel = 'noopener'; a.style.display = 'none';
    document.body.appendChild(a); a.click();
    setTimeout(function () { a.remove(); }, 0);
    setTimeout(function () { URL.revokeObjectURL(url); }, 120000);
    return url;
  }
  D.guardar = function (nombre) { var b = this.bytes(); this.ultimo = b; return descargar(b, nombre); };

  function fechaHoy(lang) {
    try { return new Intl.DateTimeFormat(lang || 'es', { dateStyle: 'long' }).format(new Date()); } catch (e) { return new Date().toISOString().slice(0, 10); }
  }
  function slug(s) { return String(s).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  function nombreArchivo(base) { var d = new Date(), p = function (x) { return ('0' + x).slice(-2); }; return 'ShivaRam-' + slug(base) + '-' + d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate()) + '.pdf'; }

  window.ShivaPDF = {
    doc: function (o) { return new Doc(o); },
    svgAJpeg: svgAJpeg, imagenAJpeg: imagenAJpeg, fechaHoy: fechaHoy, nombreArchivo: nombreArchivo,
    ancho: ancho, AW: AW, ML: ML, PW: PW, PH: PH, C: C
  };
})();
